<script setup lang="ts">
/* COMPONENTS */
import DrawerContent from '@/components/drawers/DrawerContent.vue';
import Overlay from '@/components/drawers/Overlay.vue';

import BatchesDrawerContent from './BatchesDrawerContent.vue';
</script>

<template>
  <Overlay overlayName="batches">
    <template #content="{ close }">
      <DrawerContent
        icon="fa-solid fa-cloud-upload"
        :title="$t('recruiter_network.queue.panel.title')"
        flexContent
        @close="close"
      >
        <BatchesDrawerContent />
      </DrawerContent>
    </template>
  </Overlay>
</template>
